<template>
  <div id="evn-overview" class="evn-overview">
    <div id="evn-cost" class="evn-cost">
      <div class="container-box cost-container">
        <h3 class="text-3xl">Verbindungskosten</h3>
        <div class="content-limiter">
          <p class="text-base">Entstandene Kosten für Verbindungen, Nachrichten & Dienste</p>
          <div class="info-box --space-2xs">
            <span class="text-base-semibold">aktueller Monat: {{costsCurrentMonth}}</span>
          </div>
          <div class="info-box --space-2xs">
            <span class="text-base-semibold">{{lastMonthName}}: {{costsLastMonth}}</span>
          </div>
        </div>
      </div>
    </div>

    <div id="evn-single-connection" class="evn-single-connection">
      <div class="container-box">
        <h3 class="text-3xl">Einzelverbindungen</h3>
        <div class="content-limiter">
          <p class="text-base">Hier findest du die aktuellen <strong>Einzelverbindungen der letzten 80 Tage</strong>, die bis zum Vortag getätigt wurden.
            Bitte beachte, dass die Angaben im Einzelverbindungsnachweis für die Abrechnung nicht maßgeblich sind, da <abbr title="gegebenenfalls">ggf.</abbr> eine verspätete Meldung durch den Netzbetreiber erfolgen kann.
          </p>
          <p class="text-base">Wähle aus von welchem Zeitraum du deine Einzelverbindungen haben möchtest.</p>
          <div class="flex-align-center space-between">
            <div class="input-field w-45 ">
              <label class="text-base-medium">Von*</label>
              <input type="text" class="input" placeholder="15.02.2025" v-model="filterStartDate"/>
              <p class="text-muted text-sm">Trage hier dein Anfangsdatum ein<br> (TT.MM.JJJJ)</p>
            </div>
            <div class="input-field w-45">
              <label class="text-base-medium">Bis*</label>
              <input type="text" class="input" placeholder="14.04.2025" v-model="filterEndDate"/>
              <p class="text-muted text-sm">Trage hier dein Enddatum ein<br> (TT.MM.JJJJ)</p>
            </div>
          </div>
          <button @click="refreshQuery()" class="button button--secondary --fit-content --align-end">
            Zeitraum aktualisieren
          </button>
          <button @click="downloadEvn()" class="button button--primary --fit-content --align-end">
            Einzelverbindungen als <abbr class="uppercase" title="Portable Document Format">pdf</abbr> herunterladen <img src="files/lidl/images/new-icons/svg/file-pdf.svg" alt="">
          </button>
        </div>

        <evn-accordion headline="Verbindungen innerhalb Deutschlands" :itemisedBillGroup="splittedItemisedBills.national"></evn-accordion>
        <evn-accordion headline="Verbindungen von Deutschland ins Ausland" :itemisedBillGroup="splittedItemisedBills.ausland"></evn-accordion>
        <evn-accordion headline="Verbindungen ins Ausland (Roaming)" :itemisedBillGroup="splittedItemisedBills.roaming"></evn-accordion>
        <evn-accordion headline="Sonstiges" :itemisedBillGroup="splittedItemisedBills.other"></evn-accordion>
        <evn-accordion headline="Aufladungen und Gutschriften" :itemisedBillGroup="splittedItemisedBills.topupAndVoucher"></evn-accordion>
      </div>
    </div>
  </div>

</template>

<script>
import transaction from '@/mixins/transaction'
import EvnAccordion from './EvnAccordion.vue'
import extraData from '../../../../mixins/extraData'
import { mapGetters } from 'vuex'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import preFilledInput from '../../../../mixins/preFilledInput'
import { validationMixin } from 'vuelidate'
import isValid from '../../../../mixins/isValid'
import axios from 'axios'
import FileSaver from 'file-saver'

const _Today = new Date()
const _FirstOfMonth = new Date()
_FirstOfMonth.setDate(1)

export default {
  name: 'EvnBillsOverview',
  components: { EvnAccordion },

  data () {
    return {
      loading: false,
      splittedItemisedBills: {
        all: [],
        national: [],
        sms: [],
        mms: [],
        ausland: [],
        roaming: [],
        topupAndVoucher: [],
        lastMonth: [],
        currentMonth: [],
        other: []
      }
    }
  },
  props: {
    extraData: {}
  },
  mixins: [
    preFilledInput('filterStartDate', 'firstOfMonth'),
    preFilledInput('filterEndDate', 'today'),
    validationMixin,
    isValid,
    extraData(),
    transaction('itemisedBills')
  ],
  methods: {
    refreshQuery () {
      this.loading = true
      this.$apollo.queries.currentCustomer.refetch({
        filter: this.getFilter()
      }).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getFilter () {
      return {
        from: this.filterStartDate,
        to: this.filterEndDate
      }
    },
    currencyFormatter: function (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(value)
    },
    $_resetSplittedItemisedBills () {
      this.splittedItemisedBills.all = []
      this.splittedItemisedBills.national = []
      this.splittedItemisedBills.roaming = []
      this.splittedItemisedBills.sms = []
      this.splittedItemisedBills.mms = []
      this.splittedItemisedBills.ausland = []
      this.splittedItemisedBills.other = []
      this.splittedItemisedBills.topupAndVoucher = []
      this.splittedItemisedBills.lastMonth = []
      this.splittedItemisedBills.currentMonth = []
    },
    $_filterCDR (bill) {
      if (bill.fromCountry === 'DE' && bill.toCountry === 'DE') {
        this.splittedItemisedBills.national.push(bill)
      } else if (bill.fromCountry === 'DE' && bill.toCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      } else if (bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterSMS (bill) {
      if (bill.fromCountry === 'DE' && bill.toCountry === 'DE') {
        this.splittedItemisedBills.national.push(bill)
      } else if (bill.fromCountry === 'DE' && bill.toCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      } else if (bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterMMS (bill) {
      if (bill.fromCountry === 'DE' && bill.toCountry === 'DE') {
        this.splittedItemisedBills.national.push(bill)
      } else if (bill.fromCountry === 'DE' && bill.toCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      } else if (bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterGPR (bill) {
      if (bill.value !== 0 && bill.value !== null && bill.fromCountry !== 'DE' && bill.fromCountry !== null) {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterSRV (bill) {
      if (bill.groupKey !== 'ABO' && bill.groupKey !== 'RCS' && bill.value !== 0) {
        bill.descriptionServices = this.extraData.descriptionServices[bill.groupKey]
        this.splittedItemisedBills.other.push(bill)
      }
    },
    $_filterSSR (bill) {
      if (bill.groupKey !== 'ABO' && bill.value !== 0) {
        bill.descriptionServices = this.extraData.descriptionServices[bill.groupKey]
        this.splittedItemisedBills.other.push(bill)
      }
    },
    $_filterCDT (bill) {
      // Aufladungen und Gutschriften
      bill.descriptionTopUps = this.extraData.descriptionTopUps[bill.groupKey]
      this.splittedItemisedBills.topupAndVoucher.push(bill)
    },
    $_isCostAddabel (bill) {
      return bill.typeKey !== 'CDT' &&
        bill.groupKey !== 'ABO' &&
        bill.typeKey !== 'INF' &&
        bill.groupKey !== 'RCS'
    },
    $_addCosts (bills) {
      if (this.$_isCostAddabel(bills)) {
        if (new Date(bills.actionDate).getMonth() === _Today.getMonth() - 1) {
          this.splittedItemisedBills.lastMonth.push(bills)
        } else if (new Date(bills.actionDate).getMonth() === _Today.getMonth()) {
          this.splittedItemisedBills.currentMonth.push(bills)
        }
      }
    },
    $_filterItemisedBills () {
      const bills = this.currentCustomer?.itemisedBills
      this.$_resetSplittedItemisedBills()
      if (bills) {
        bills.forEach((bill, index) => {
          this.$_addCosts(bill)
          switch (bill.typeKey) {
            case 'CDR':
              this.$_filterCDR(bill)
              break
            case 'SMS':
              this.$_filterSMS(bill)
              break
            case 'MMS':
              this.$_filterMMS(bill)
              break
            case 'GPR':
            case 'GPRS':
              this.$_filterGPR(bill)
              break
            case 'CDT':
              this.$_filterCDT(bill)
              break
            case 'SRV':
              this.$_filterSRV(bill)
              break
            case 'SSR':
              this.$_filterSSR(bill)
              break
            case 'INF':
              break
          }
        })
      }
    },
    displayCountEntries (list) {
      return list.length >= 1 ? (list.length < 2 ? '1 Eintrag' : `${list.length} Einträge`) : ''
    },
    downloadEvn: function () {
      if (!this.downloadPending || this.btnAlreadyClicked) {
        this.downloadPending = true
        const me = this
        axios.get('api/document/' + this.filterStartDate + '/' + this.filterEndDate, {
          baseURL: this.$config.apiUrl || '',
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
            Accept: 'text/csv'
          },
          responseType: 'blob'
        }).then((response) => {
          const file = new Blob([response.data], { type: response.headers['content-type'] })
          FileSaver.saveAs(file, 'EVN-Zusammenfassung ' + this.filterStartDate + '-' + this.filterEndDate + '.csv')
          this.downloadPending = false
        }).catch((reason) => {
          me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
          this.downloadPending = false
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    lastMonthName () {
      const monthNames = ['Januar ', 'Februar ', 'März ', 'April ', 'Mai ', 'Juni ',
        'Juli ', 'August ', 'September ', 'Oktober ', 'November ', 'Dezember '
      ]
      const monthName = monthNames[_Today.getMonth() - 1] || 'Dezember '
      return monthName + _Today.getFullYear()
    },
    costsLastMonth () {
      return this.currencyFormatter(this.splittedItemisedBills.lastMonth.map(e => e.value / 10000).reduce((a, b) => a + b, 0))
    },
    costsCurrentMonth () {
      return this.currencyFormatter(this.splittedItemisedBills.currentMonth.map(e => e.value / 10000).reduce((a, b) => a + b, 0))
    },
    minDate () {
      const mindate = new Date()
      mindate.setDate(mindate.getDate() - 80)
      return mindate
    },
    today () {
      return this.$config.calendar.formatter.dateFormatter.format(_Today)
    },
    firstOfMonth () {
      return this.$config.calendar.formatter.dateFormatter.format(_FirstOfMonth)
    }
  },
  apollo: {
    currentCustomer: function () {
      const me = this
      me.loading = true
      return wrapQuery(
        gql`query itemisedBills ($filter: ItemisedBillFilterInput){
        currentCustomer {
          contract {
            msisdn
          }
          itemisedBills(filter: $filter) {
            actionDate
            destination
            details
            duration
            fromCountry
            groupKey
            id
            productCode
            requestorID
            toCountry
            typeKey
            value
          }
        }
      }`, this, 'currentCustomer', {
          filter: this.getFilter()
        }, () => {
          this.$_filterItemisedBills()
          me.loading = false
        }, {},
        () => {
          me.loading = false
        }
      )
    }
  }
}
</script>
